import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/past_games/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/past_games/FULFILLED';
export const REJECT = 'WIS/taxonomy/past_games/REJECTED';

export type PastGamesActionTypes = 
  'WIS/taxonomy/past_games/DISPATCHED'
  | 'WIS/taxonomy/past_games/FULFILLED'
  | 'WIS/taxonomy/past_games/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });

const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyPastGamesAction = TaxonomyAction<PastGamesActionTypes>;

export default function reducer(state = initialState, action: TaxonomyPastGamesAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
